import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {JourneyService} from '../../service/journey.service';

class CustomAttendanceModel {
    // tslint:disable-next-line:variable-name
    attend_need: boolean;
    // tslint:disable-next-line:variable-name
    prog_del_id: number;
}


@Component({
    selector: 'app-journey-list-template-attendance',
    templateUrl: './list-template-attendance.component.html',
    styleUrls: ['./list-template-attendance.component.scss']
})
export class LearningJourneyListTemplateAttendanceComponent implements OnInit {

    details: CustomAttendanceModel = null;
    title: string = null;
    description: string = null;

    @Input('data') set setDetails(data) {
        if (!!data) {
            this.details = data.details.confirm_attendance;
            this.title = data.title;
            this.description = data.text;
        }
    }

    constructor(
        private journeyService: JourneyService
    ) {
    }

    ngOnInit() {
    }

    changeAttendance(status) {
        /*if (this.level === 'learner') {*/
        this.journeyService.updateMyDiaryAttendance(this.details.prog_del_id, status)
            .then(responce => {
            });
        /*}*/
    }


}
